import { Modal, Form, Button } from "react-bootstrap";
import * as yup from "yup";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import MultiselectTreeCtrl from "../userDashboard/MultiselectTreeCtrl";
import {BiSave, BiX} from "react-icons/bi";
import {useLazyAddEditFacilitiesQuery} from "app/redux/Facility/facilityApi";
import DropdownTreeSelect from "react-dropdown-tree-select";
export default function TreeViewDropDownDialog(props) {
  const [accessData, setAccessDataState] = useState([]);
  const [addEditFacilities] = useLazyAddEditFacilitiesQuery();
  const { open,  eventObject, handleSubmit, closeDialog } = props;

  const OptionsAccessGroup = eventObject.OptionsAccessGroup;
  const OptionsPUIncluded = eventObject.OptionsPUIncluded;
  const OptionsPUExcluded = eventObject.OptionsPUExcluded;
  const initialState = {
    loginUserName: localStorage.getItem("loginUserName") ?? "",
    loginUserPersonId: localStorage.getItem("loginUserPersonId") ?? "",
    loginUserEmail: localStorage.getItem("loginUserEmail") ?? "",
  };
  let selectedAccessGroups = [];
  let selectedIncludePropUnits = getDefaultSelectedFromOptions(OptionsPUIncluded);
  let selectedExcludePropUnits = getDefaultSelectedFromOptions(OptionsPUExcluded);



  useEffect(() => {

    let tempdata = eventObject.groupData;
    let selectedItems = eventObject.selectedGroup;


    if(tempdata && Array.isArray(tempdata) && tempdata.length > 0){
       //  console.log('USEEFFECT ---------------------------------- ',);
        //Select preselect data
        if(selectedItems && Array.isArray(selectedItems) && selectedItems.length > 0){
          tempdata.forEach((item) => {
              let ConcatID = item.ConcatID;
              if(item.checked === true){
                  item.checked =  false;
              }
              var check = selectedItems.filter(a => a.ConcatID === ConcatID && a.AccessType === 'Direct');
              if(check && check.length > 0){
                  item.checked = true;
              }
              let entrance = item.children;
              if(entrance && Array.isArray(entrance) && entrance.length > 0){
                  entrance.forEach((entraceitem) => {
                      var entranceCheck = selectedItems.filter(a => a.ConcatID === entraceitem.ConcatID&& a.AccessType === 'Direct');
                      if(entranceCheck && entranceCheck.length > 0){
                          entraceitem.checked = true;
                      }
                      let floor = entraceitem.children;
                      if(floor && Array.isArray(floor) && floor.length > 0){
                          floor.forEach((floorItem) => {
                              var floorCheck = selectedItems.filter(a => a.ConcatID === floorItem.ConcatID&& a.AccessType === 'Direct');
                              if(floorCheck && floorCheck.length > 0){
                                  floorItem.checked = true;
                              }
                          });
                          entraceitem.children = floor;
                      }
                  });
                  item.children = entrance;
              }
          });
      }

        selectedAccessGroups = prepareDefaultSelectedAccessGroup(tempdata, selectedItems);
        setAccessDataState(tempdata);
    }
    else{
        setAccessDataState(tempdata);
    }

  }, [eventObject, accessData]);



  const handleFormSubmit  = async (values) => {
    // console.log('selectedData - ', selectedAccessGroups, selectedIncludePropUnits, selectedExcludePropUnits)
    await UpdatetFacilityData(selectedAccessGroups, selectedIncludePropUnits, selectedExcludePropUnits);
    handleSubmit(true);
    closeDialog();
    /*if(selectedItems && Array.isArray(selectedItems) && selectedItems.length > 0){
      console.log('Selected items at parent', selectedItems)
      UpdatetFacilityData(selectedItems);
    }
    handleSubmit(values);
    */
  };

  const updateSelectedItems = (selectedItems) => {
     // console.log('Selected items at parent', selectedItems)
      selectedAccessGroups = selectedItems;
  }

    const updateSelectedIncludes = (selectedItems) => {
       // console.log('Selected items at parent', selectedItems)
        selectedIncludePropUnits = selectedItems;
    }

    const updateSelectedExcludes = (selectedItems) => {
       // console.log('Selected items at parent', selectedItems)
        selectedExcludePropUnits = selectedItems;
    }

  const UpdatetFacilityData = async (selectedAccessGroups, selectedIncludePropUnits, selectedExcludePropUnits) => {
    let obj = {};
    obj["screenType"] = "Edit";
    obj["id"] = eventObject.facilityId;
    obj["companyid"] = eventObject.selectedCompanyId
    obj["name"] = initialState.loginUserName;
    obj["updatedBy"] = initialState.loginUserPersonId;
    let affectedPU = [];
    let IncludeinAffectedList = [];
    let ExcludeInAffectedList = [];
    if (Array.isArray(selectedAccessGroups)){
      selectedAccessGroups.forEach((item) => {
        let obj1 = {};
        obj1["ConcatID"] = item.ConcatID;
        obj1["PropertyID"] = item.PropertyID;
        obj1["FloorID"] = item.FloorID;
        obj1["EntranceID"] = item.EntranceID;
        obj1["ConnectedType"] = item.Type;
        affectedPU.push(obj1);
      })
    }

    if (Array.isArray(selectedIncludePropUnits)){
      selectedIncludePropUnits.forEach((item) => {
        let obj1 = {};
        obj1["ID"] = item.ID;
        obj1["Name"] = item.Name;
        IncludeinAffectedList.push(obj1);
      })
    }

    if (Array.isArray(selectedExcludePropUnits)){
      selectedExcludePropUnits.forEach((item) => {
        let obj1 = {};
        obj1["ID"] = item.ID;
        obj1["Name"] = item.Name;
        ExcludeInAffectedList.push(obj1);
      })
    }

    obj["affectedPUDetailedData"] = affectedPU;
    obj["IncludeinAffectedList"] = IncludeinAffectedList;
    obj["ExcludeInAffectedList"] = ExcludeInAffectedList;

    //console.log('saving obj - ', obj);
     await addEditFacilities(obj).then((result) => {
       //console.log(result);
         closeDialog();
     });
    //  console.log('save obj - ', obj);
  };

  return (
    <Modal show={open} onHide={closeDialog} size="">
      <Formik
        enableReinitialize={true}
        initialValues={eventObject}
        onSubmit={handleFormSubmit}
        validationSchema={eventSchema}>
            
        {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => {
          return (
            <>
              <Modal.Header className="bg-primary text-white d-flex flex-wrap justify-content-between align-items-center">
                <h4 className="m-0 text-white">Rediger anlegg</h4>
                <i className="i-Close-Window cursor-pointer text-18" onClick={closeDialog} />
              </Modal.Header>

              <Modal.Body>
                <Form onSubmit={handleSubmit}>
                  <Form.Group>
                      <Form.Label>Tilgangsgruppe</Form.Label>
                      {
                          <MultiselectTreeCtrl refId={'access-groupx'} outSelectedItem={updateSelectedItems} options={OptionsAccessGroup}></MultiselectTreeCtrl>
                      }

                      <Form.Label>Inkluder eiendomsenheter</Form.Label>
                      <MultiselectTreeCtrl refId={'include-propunits'}   outSelectedItem={updateSelectedIncludes} options={OptionsPUIncluded}></MultiselectTreeCtrl>


                      <Form.Label>Ekskluder eiendomsenheter</Form.Label>
                      <MultiselectTreeCtrl refId={'exclude-propunits'}   outSelectedItem={updateSelectedExcludes} options={OptionsPUExcluded}></MultiselectTreeCtrl>


                  </Form.Group>
                </Form>
              </Modal.Body>
                <Modal.Footer className={''}>
                    <Button variant="secondary" onClick={closeDialog}>
                        <BiX  size={17}></BiX>
                        Lukke
                    </Button>

                    <Button   onClick={() => handleFormSubmit(accessData)} variant="primary"  >
                        <BiSave  size={17}></BiSave>   Lagre endringer
                    </Button>
                </Modal.Footer>
            </>
          );
        }}
      </Formik>
    </Modal>
  );
}

const eventSchema = yup.object().shape({
  title: yup.string().required("Title is required"),
  start: yup.string().required("Start date is required")
});


export const getDefaultSelectedFromOptions = ((options: any) => {
    const checkedItems = [];
    if(Array.isArray(options)){
        options.forEach(item => {
            if(item.checked){
                checkedItems.push(item);
            }
        })
    }
    return checkedItems;
})

export const prepareDefaultSelectedAccessGroup = (treeOptions: any, selectedItems: any) => {
    console.log('prepareDefaultSelectedAccessGroup', selectedItems);
    const optionsByConcatId = getOptionsByConcatId(treeOptions);
    const refinedItems: any = [];
    if(Array.isArray(selectedItems)){
        selectedItems.forEach((item: any) => {

            /*
                obj1["ConcatID"] = item.ConcatID;
                obj1["PropertyID"] = item.PropertyID;
                obj1["FloorID"] = item.FloorID;
                obj1["EntranceID"] = item.EntranceID;
                obj1["ConnectedType"] = item.Type;
             */
            const optionItem: any = optionsByConcatId[item.ConcatID];
            if(optionItem){
                const newItem = {
                    ConcatID: optionItem.ConcatID,
                    PropertyID: optionItem.PropertyID,
                    FloorID: optionItem.FloorID,
                    EntranceID: optionItem.EntranceID,
                    ConnectedType: optionItem.Type,
                }
                refinedItems.push(newItem);
            }
        })
    }
    return refinedItems;
};

export const getOptionsByConcatId =  (treeOptions: any) => {
    let optionsByConcatId = {};
    if(Array.isArray(treeOptions)){
        treeOptions.forEach(item => {
            optionsByConcatId[item.ConcatID] = item;
            if(Array.isArray(item.children) && item.children.length){
                const resultForChild = getOptionsByConcatId(item.children);
                optionsByConcatId = {...optionsByConcatId, ...resultForChild};
            }
        })
    }
    return optionsByConcatId;
}